export default __webpack_public_path__ + "static/benefitsBg-79202955d7b17a0dafc600a4eff62211.png";